import { render, staticRenderFns } from "./RewardDelete.vue?vue&type=template&id=ab00f136"
import script from "./RewardDelete.vue?vue&type=script&lang=js"
export * from "./RewardDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports